import React, { Suspense, useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';

// Preloader
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));

// Pages
const Home = React.lazy(() => import("./components/pages/Home"));

const Privacy = React.lazy(() => import("./components/pages/Privacy"));
const Tnc = React.lazy(() => import("./components/pages/Tnc"));
const HouseRules = React.lazy(() => import("./components/pages/HouseRules"));


// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return children || null
})


function App() {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <Preloader />
          <Route path="/" exact component={Home} />
          <Route path="/privacy" exact component={Privacy} />
          <Route path="/tnc" exact component={Tnc} />
          <Route path="/house-rules" exact component={HouseRules} />
        </ScrollToTop>
      </Suspense>
    </Router>
  );
}

export default App;
